module.exports = __webpack_public_path__ + "img/pay-error.56e3bad7.gif";